module.exports = __webpack_public_path__ + "media/assets/images/en-7e200d4671be38a38a648e39a76fc636.png";